module.exports = __webpack_public_path__ + "static/media/orthene_ultra.2759d09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/picudo_banano/curativa/orthene_ultra.png
// module id = 1166
// module chunks = 3